export const FUEL_OPTIONS = [
  { key: 'petrol', label: 'vehicle_taxonomies.fuel.petrol' },
  { key: 'diesel', label: 'vehicle_taxonomies.fuel.diesel' },
  { key: 'electric', label: 'vehicle_taxonomies.fuel.electric' },
  { key: 'hybrid', label: 'vehicle_taxonomies.fuel.hybrid' },
  { key: 'petrol-hev', label: 'vehicle_taxonomies.fuel.petrol_hev' },
  { key: 'diesel-hev', label: 'vehicle_taxonomies.fuel.diesel_hev' },
  { key: 'electric-phev', label: 'vehicle_taxonomies.fuel.electric_phev' },
  { key: 'glp', label: 'vehicle_taxonomies.fuel.glp' },
];

export const TRANSMISSION_OPTIONS = [
  { key: 'manual', label: 'vehicle_taxonomies.transmission.manual' },
  { key: 'automatic', label: 'vehicle_taxonomies.transmission.automatic' },
  { key: 'semi-automatic', label: 'vehicle_taxonomies.transmission.semi_automatic' },
  { key: 'cvt', label: 'vehicle_taxonomies.transmission.cvt' },
];

export const DRIVETRAIN_OPTIONS = [
  { key: 'fwd', label: 'vehicle_taxonomies.drivetrain.fwd' },
  { key: 'rwd', label: 'vehicle_taxonomies.drivetrain.rwd' },
  { key: '4wd', label: 'vehicle_taxonomies.drivetrain.4wd' },
];

export const EMISSIONS_LABEL_OPTIONS = [
  { key: 'b', label: 'vehicle_taxonomies.emissions_label.b' },
  { key: 'c', label: 'vehicle_taxonomies.emissions_label.c' },
  { key: 'eco', label: 'vehicle_taxonomies.emissions_label.eco' },
  { key: 'zero', label: 'vehicle_taxonomies.emissions_label.zero' },
];
